import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { PaymentType } from '../entities';
import { updatePaymentType } from '../store/actions';
import { getPaymentType } from '../store/selectors';

export const usePaymentType = () => {
  const dispatch = useDispatch();
  const paymentType = useSelector(getPaymentType);

  const doUpdatePaymentType = useCallback(
    (type: PaymentType) => {
      dispatch(updatePaymentType(type));
    },
    [dispatch],
  );

  return { paymentType, updatePaymentType: doUpdatePaymentType };
};
